import { useGetUnitDetailStats } from '@apps-common/apis/portal/unit'
import { UnitControls, UnitManageCard, UnitManageCardSkeleton } from '@apps-common/apps/portal/pages/units/pages/manage/components'
import { commonIcons } from '@apps-common/config/icons'
import { unitIsActive, unitIsCancelled, unitIsInactive } from '@apps-common/helpers/unit-helpers'
import { useNavigation } from '@apps-common/hooks/useNavigation'
import { IUnitGenericDetailsModel } from '@apps-common/types/portal/unit'
import { ROUTE_UNIT_SCHEDULES, ROUTE_UNIT_TRIGGERS, ROUTE_UNIT_USERS, ROUTE_UNIT_ZONES } from '@apps-radionet-portal/config/private-routes'

interface IProps {
  layoutPrefix: string
  unit?: IUnitGenericDetailsModel
}

export const UnitManageContainer: React.FC<IProps> = ({ layoutPrefix, unit }) => {
  const { navigateForward } = useNavigation()
  const { isLoading, isFetching, data } = useGetUnitDetailStats({
    config: {
      enabled: !!unit
    },
    id: unit?.unitId || ''
  })

  const UNIT_DETAILS_KPI_MAP = [
    // {
    //   keys: ['myMonitoringUsers'],
    //   label: 'myMonitoring Users',
    //   IconLight: <div>Icon Light</div>,
    //   IconDark: <div>Icon Dark</div>,
    //   route: ROUTE_UNIT_USERS
    // },
    // {
    //   keys: ['namedUsers'],
    //   label: 'Defined Users',
    //   IconLight: <div>Icon Light</div>,
    //   IconDark: <div>Icon Dark</div>,
    //   route: ROUTE_UNIT_USERS
    // },
    {
      keys: ['myMonitoringUsers', 'namedUsers'],
      label: 'Users',
      Icon: commonIcons.users,
      route: ROUTE_UNIT_USERS,
      disableOnInactive: true
    },
    {
      keys: ['customZones'],
      label: 'Zones',
      Icon: commonIcons.zones,
      route: ROUTE_UNIT_ZONES
    },
    // {
    //   keys: ['notes'],
    //   label: 'Notes',
    //   Icon: commonIcons.notes,
    //   route: ROUTE_UNIT_NOTES
    // },
    {
      keys: ['schedules'],
      label: 'Schedules',
      Icon: commonIcons.schedule,
      route: ROUTE_UNIT_SCHEDULES,
      disableOnInactive: true
    },
    {
      keys: ['triggers'],
      label: 'Triggers',
      Icon: commonIcons.trigger,
      route: ROUTE_UNIT_TRIGGERS,
      disableOnInactive: true
    }
  ]

  const isActive = unitIsActive(unit)
  const isInactive = unitIsInactive(unit)
  const isCancelled = unitIsCancelled(unit)

  const loading = !unit || isLoading || isFetching || !data

  return (
    <div className='w-full'>
      <div className='grid grid-cols-3 sm:grid-cols-3 gap-[10px] md:gap-[10px] p-1'>
        {loading && UNIT_DETAILS_KPI_MAP.map((k, i) => <UnitManageCardSkeleton key={`unit-manage-card-skeleton-${i}`} />)}
        {!loading && unit && (
          <>
            {UNIT_DETAILS_KPI_MAP.map((k, i) => {
              const value = k.keys.reduce((acc, key) => {
                const num = (data as any)[key]

                if (typeof num === 'number') {
                  return acc + num
                }

                return acc
              }, 0)

              return (
                <UnitManageCard
                  key={`unit-manage-card-${i}`}
                  unitId={unit?.unitId}
                  count={value}
                  label={k.label}
                  Icon={k.Icon}
                  // route={k.route}
                  bgClasses='bg-surface border border-border'
                  textClasses='text-text'
                  bgSecondaryClasses='bg-surface-2'
                  textSecondaryClasses='text-text'
                  bgTertiaryClasses='bg-brand !text-on-brand'
                  bgActiveClasses='bg-surface'
                  disabled={k.disableOnInactive && isInactive}
                  callback={() =>
                    navigateForward({
                      routeUrl: k.route.path.replace(':status', unit?.status).replace(':unitId', unit?.unitId),
                      route: k.route
                    })
                  }
                />
              )
            })}
          </>
        )}
        <div className='col-span-2'>
          <UnitControls layoutPrefix={layoutPrefix} unitId={unit?.unitId} isActivated={isActive && !isCancelled} />
        </div>
      </div>
    </div>
  )
}
